import React from 'react'

import { Column, ColumnEditorOptions } from 'primereact/column'
import { TreeTableProps } from 'primereact/treetable'

import { ColumnConfig } from '../../../../features/ui-config'
import { getConfigTranslation } from '../../../helper/getConfigTranslation'
import { resolveValueByPath } from '../../../helper/resolveValueByPath'
import { getDataType, getFilterTemplate } from '../getter'
import { getBodyTemplate } from '../getter/getBodyTemplate'

export const navigationColumn = (
  <Column
    key="navigationColumn"
    field="icon"
    header=""
    body={<i className="pi pi-angle-right text-primary text-2xl"></i>}
    frozen
    alignFrozen="right"
    align="right"
  />
)

export function createTreeColumns(
  configColumns: ColumnConfig[],
  props: TreeTableProps,
  checkboxen?: boolean,
  buttons?: JSX.Element,
  children?: JSX.Element[],
) {
  // const checkboxColumn = checkboxen && (
  //   <Column
  //     key="checkboxColumn"
  //     selectionMode="multiple"
  //     frozen
  //     alignFrozen="left"
  //     className="w-3rem"
  //   />
  // )

  // const emptyColumn = <Column key="emptyColumn" field="" header="" />

  // Process child columns if provided
  let childColumns = children?.map((child: JSX.Element) => {
    const columnField = child.props.field

    // Find the corresponding config for the column
    const matchingConfig = configColumns.find(
      configColumn => configColumn.field === columnField,
    )

    if (matchingConfig?.enabled === false) return

    if (matchingConfig) {
      return React.cloneElement(child, {
        ...matchingConfig, // Merge config data
        header:
          getConfigTranslation(matchingConfig?.header) ?? child.props.header, // Update header
        align: matchingConfig.align ?? child.props.align,
        // body: (rowData: unknown) =>
        //   getBodyTemplate(
        //     matchingConfig.dataType,
        //     resolveValueByPath(matchingConfig.field || '', rowData),
        //     rowData,
        //   ),
        // editor: child.props.editor ?? ((options: ColumnEditorOptions) => <></>),
        // filter: matchingConfig.filter ?? false,
        // filterElement: matchingConfig.filter
        //   ? getFilterTemplate(matchingConfig.dataType)
        //   : undefined,
        // style: {
        //   ...child.props.style,
        //   width: matchingConfig.width,
        //   minWidth: matchingConfig.minWidth,
        // },
      })
    }

    // If no matching config, return the child as is
    return child
  })

  // Generate columns from configColumns if no children provided
  // if (!childColumns || childColumns.length === 0) {
  //   childColumns = configColumns
  //     .filter(column => column.enabled !== false)
  //     .map(column => (
  //       <Column
  //         key={column.filterField || column.field}
  //         align={column.align ?? 'left'}
  //         // body={(rowData: unknown) =>
  //         //   getBodyTemplate(
  //         //     column.dataType,
  //         //     resolveValueByPath(column.filterField || column.field, rowData),
  //         //     rowData,
  //         //   )
  //         // }
  //         editor={(options: ColumnEditorOptions) => <></>}
  //         dataType={getDataType(column.dataType)}
  //         field={column.filterField ? undefined : column.field}
  //         filter={column.filter ?? false}
  //         filterField={column.filterField}
  //         // filterElement={getFilterTemplate(column.dataType)}
  //         filterMenuStyle={{ minWidth: '16em' }}
  //         filterPlaceholder={getConfigTranslation(column?.filterPlaceholder)}
  //         header={getConfigTranslation(column?.header)}
  //         sortable={column.sortable ?? false}
  //         sortField={column.sortField}
  //         style={{ width: column.width, minWidth: column.minWidth }}
  //       />
  //     ))
  // }

  // if (checkboxColumn) {
  //   childColumns.unshift(checkboxColumn)
  // }

  // if (buttons) {
  //   childColumns.push(
  //     React.cloneElement(buttons, {
  //       frozen: true,
  //       align: 'right',
  //       alignFrozen: 'right',
  //     }),
  //   )
  // }

  // If a column has a width property there must be an empty column
  // at the end because otherwise PrimeReact tries to distribute
  // the column width equal to the table width so the last empty
  // column takes up the remaining space
  // const hasWidthProperty = configColumns.some(column =>
  //   column.hasOwnProperty('width'),
  // )

  // if (hasWidthProperty && !buttons) {
  //   childColumns.push(emptyColumn)
  // }

  return childColumns
}
